import type { SellerApplicationRejectionKind } from './api';

/** Как на бэкенде (`seller-application-rejection.constants.ts`). */
export const SELLER_APPLICATION_REJECTION_LABELS: Record<
  SellerApplicationRejectionKind,
  string
> = {
  POOR_DOCUMENT_PHOTOS: 'Некачественные фото документов',
  DATA_MISMATCH: 'Несоответствие данных документов сведениям в анкете',
  INCOMPLETE_DOCUMENTS: 'Неполный комплект документов',
  REQUIRES_REVISION: 'Требуется доработка заявки',
};
